import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function studyDataReducer(
  state = initialState.studyData,
  action
) {
  switch (action.type) {
    case types.LOADED_STUDY_DATA_SUCCESS:
      return action.studyData;
    default:
      return state;
  }
}
